import _toConsumableArray from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
var _excluded = ["signers"];
import _regeneratorRuntime from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseWalletAdapter } from './adapter.mjs';
import { WalletError, WalletSendTransactionError } from './errors.mjs';
export var BaseSignerWalletAdapter = /*#__PURE__*/function (_BaseWalletAdapter) {
  _inherits(BaseSignerWalletAdapter, _BaseWalletAdapter);

  var _super = _createSuper(BaseSignerWalletAdapter);

  function BaseSignerWalletAdapter() {
    _classCallCheck(this, BaseSignerWalletAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(BaseSignerWalletAdapter, [{
    key: "sendTransaction",
    value: function () {
      var _sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transaction, connection) {
        var options,
            emit,
            _transaction,
            signers,
            sendOptions,
            rawTransaction,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                emit = true;
                _context.prev = 2;
                _context.prev = 3;
                transaction.feePayer = transaction.feePayer || this.publicKey || undefined;
                _context.t0 = transaction.recentBlockhash;

                if (_context.t0) {
                  _context.next = 10;
                  break;
                }

                _context.next = 9;
                return connection.getRecentBlockhash('finalized');

              case 9:
                _context.t0 = _context.sent.blockhash;

              case 10:
                transaction.recentBlockhash = _context.t0;
                signers = options.signers, sendOptions = _objectWithoutProperties(options, _excluded);
                (signers === null || signers === void 0 ? void 0 : signers.length) && (_transaction = transaction).partialSign.apply(_transaction, _toConsumableArray(signers));
                _context.next = 15;
                return this.signTransaction(transaction);

              case 15:
                transaction = _context.sent;
                rawTransaction = transaction.serialize();
                _context.next = 19;
                return connection.sendRawTransaction(rawTransaction, sendOptions);

              case 19:
                return _context.abrupt("return", _context.sent);

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](3);

                if (!(_context.t1 instanceof WalletError)) {
                  _context.next = 27;
                  break;
                }

                emit = false;
                throw _context.t1;

              case 27:
                throw new WalletSendTransactionError(_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message, _context.t1);

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t2 = _context["catch"](2);

                if (emit) {
                  this.emit('error', _context.t2);
                }

                throw _context.t2;

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 30], [3, 22]]);
      }));

      function sendTransaction(_x, _x2) {
        return _sendTransaction.apply(this, arguments);
      }

      return sendTransaction;
    }()
  }]);

  return BaseSignerWalletAdapter;
}(BaseWalletAdapter);
export var BaseMessageSignerWalletAdapter = /*#__PURE__*/function (_BaseSignerWalletAdap) {
  _inherits(BaseMessageSignerWalletAdapter, _BaseSignerWalletAdap);

  var _super2 = _createSuper(BaseMessageSignerWalletAdapter);

  function BaseMessageSignerWalletAdapter() {
    _classCallCheck(this, BaseMessageSignerWalletAdapter);

    return _super2.apply(this, arguments);
  }

  return _createClass(BaseMessageSignerWalletAdapter);
}(BaseSignerWalletAdapter);